import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const HeaderSectionStyled = styled.div`
  padding: 2rem 0;
  border-bottom: 1px solid ${colors.neutral[300]};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;
